import DocHandlerTemplates from "./DocHandlerTemplates.component";

export default DocHandlerTemplates;
